import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/license/plan/update/license.plan.update.mutation.gql"
import type {
  LicensePlanUpdateMutation,
  LicensePlanUpdateMutationVariables,
} from "@/v2-backoffice-client/license/plan/update/__types__/license.plan.update.mutation"

type Options = MutationHookOptions<
  LicensePlanUpdateMutation,
  LicensePlanUpdateMutationVariables
>

export function useLicensePlanUpdateMutation(options?: Options) {
  return useMutation<
    LicensePlanUpdateMutation,
    LicensePlanUpdateMutationVariables
  >(mutation, options)
}
